<template>
    <div class="pre-loader" style="display: none;">
        <div class="loader-overlay">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader'
}
</script>
<style scoped>
.pre-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
    background: var(--preloader-bg);
  }
  
  .loader-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  
  .loader {
    border-width: 16px;
    border-style: solid;
    border-color: var(--loader-border-main) var(--loader-border-secondary) var(--loader-border-secondary);
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
  }
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>